/**
 * Controls whether or not we use server components to render the logged in home page
 */
export const NEXTJS_RSC_LOGGED_IN_HOME_PAGE_240411 = 'NEXTJS_RSC_LOGGED_IN_HOME_PAGE_240411';
